<template>
    <div>
        <div class="text-16px color-#fff font-900 text-center pb-20px">
            {{ t('chatSettings.chatModel') }}
        </div>

        <div class="max-h-400px overflow-y-auto" v-if="modelList&&modelList.length>0">
            <div class="w-100% mb-10px model-box relative" v-for="(item, index) in modelList"
                @click="handleCheck(index, item)"
                :class="[item.isChecked ? 'active' : '', item.cost === maxValue ? 'isCostSee' : '', item.id === 3 && item.isChecked ? 'ishot' : '']">
                <div class="flex justify-between">
                    <div class="text-14px color-#fff flex-shrink-0 font-500 flex w-110px items-center">
                        <div v-if="item.id === 3" class="w-11px w-13px flex items-center justify-center mr-4px mb-1px">
                            <img src="@/assets/images/message/vip_model.svg" alt="" class="w-full h-full">
                        </div>
                        <div v-if="item.isVipSee || item.isCostSee"
                            class="w-11px w-13px flex items-center justify-center mr-4px mb-1px">
                            <img src="@/assets/images/message/vip_icon.svg" alt="" class="w-full h-full">
                        </div>
                        <div>
                            {{ item.title }}
                        </div>
                    </div>
                    <div class="cost py-0px flex items-center rounded-12px pl-6px pr-8px ml-10px h-23px">
                        <div class="w-6px h-10px flex mr-3px">
                            <img src="@/assets/images/message/crystal.svg" />
                        </div>
                        <div class="color-#ABB6FF text-10px font-500">
                            {{ item.cost }}/Message
                        </div>
                    </div>
                </div>

                <div class="text-10px py-6px model-text">
                    {{ item.description }}
                </div>
                <div class="flex thinking justify-between my-5px" v-if="false">
                    <div class="model-text">
                        Thinking
                    </div>
                    <div class="flex">
                        <div class="flex items-center">
                            <img src="@/assets/images/message/vip_icon.webp" alt="" class="w-20px mr-12px">
                        </div>
                        <div class="flex items-center" @click.stop="handleCheckThinking(index, item)">
                            <img src="@/assets/images/message/check.svg" v-if="!item.isThinkingChecked"
                                class="w-full h-full"></img>
                            <img src="@/assets/images/message/check_on.svg" v-else class="w-full h-full"></img>
                        </div>
                    </div>
                </div>
                <div v-if="item.isChecked" class="w-16px h-16px flex item-centers  absolute bottom--1px right--1px">
                    <img src="@/assets/images/message/hot-check.svg" v-if="item.id === 3" alt="" class="w-full h-full">
                    <img src="@/assets/images/message/gouyxuan.svg" alt="" class="w-full h-full" v-else>
                </div>
                <!-- <div class="absolute top-0 right-0" v-if="item.isCostSee">
                            <img src="@/assets/images/message/vip_icon.webp" alt="" class="w-20px mr-12px">
                        </div> -->
                <FirstChargePopUp v-model:showPopup="showPopupFirstCharge" url="/" />

            </div>
        </div>
        <div class="py-40px flex items-center justify-center" v-else>
            <van-loading type="spinner" color="#fff" size="24px" />
        </div>
    </div>
</template>
<script lang="ts" setup>
import FirstChargePopUp from '@/views/home/com/FirstChargePopUp.vue'
import { ref, onMounted, computed, watch } from 'vue'
import { showSuccessToast, showLoadingToast } from '@/utils/toast'
import { MessageAPI } from '@/services/message'
import { useUserStore } from '@/stores/user'
import { useI18n } from 'vue-i18n'
import router from '@/router'

const { t } = useI18n()
const maxValue = ref(0)
const isThinking = ref()
const userStore = useUserStore()
const infoData = computed(() => userStore.getTouristInfo())
const showPopupFirstCharge = ref(false)
const active = ref(0)

const props = defineProps<{
    close: () => void
    modelList: any[]
    getModelList: () => void
}>()

const modelList = computed<any[]>(() =>
    props.modelList || []
)

const getModelList = async () => {
    let a = Math.max(...modelList.value.map(item => item.cost))
    maxValue.value = a
    setThinkingToast()
    localStorage.setItem('modelIndex', String(modelList.value.find((item: any) => item.isChecked === true)?.id))
}
const setThinkingToast = () => {
    isThinking.value = modelList.value.find(item => item.isChecked === true)?.isThinking
}

/**
 * 切换思考
*/
const handleCheckThinking = async (index: number, item: any) => {
    
    if (![3, 4].includes(infoData.value.role)) {
        showPopupFirstCharge.value = true
        props.close()
        return
    }
    showLoadingToast('loading...')
    active.value = index
    if (item.isThinkingChecked) {
        item.isThinkingChecked = false
    } else {
        item.isThinkingChecked = true
    }
    await MessageAPI.setUserChatModel({
        chatModelId: item.id,
        chatThinking: item.isThinkingChecked ? 1 : 0,
    })
    showSuccessToast(t('message.successfulSwitch'))
    userStore.setIsThinking(item.isThinkingChecked)


}

/**
 * 切换模型
*/
const handleCheck = async (index: number, item: any) => {
    if (item.isChecked) {
        return
    }
    if (item.isCostSee) {
        if (![3,4,5].includes(infoData.value.role)) {
            showPopupFirstCharge.value = true
            return
        }
    }
    if(item.isVipSee){
        if(![4,5].includes(infoData.value.role)){
            router.push({ name: 'Vip', query: { type: 'u' } })
            return
        }
    }

    showLoadingToast()
    await MessageAPI.setUserChatModel({
        chatModelId: item.id,
    })
    active.value = index
    localStorage.setItem('modelIndex', String(item.id))
    props.getModelList()
    modelList.value.forEach((item: any) => {
        item.isChecked = false
    })
    item.isChecked = !item.isChecked

    showSuccessToast(t('message.successfulSwitch'), { duration: 1000 })
    userStore.setChatExpenses(item.cost)
    props.close()
}

/**
 * 监听 modelList 变化
 */
watch(() => props.modelList, (newVal) => {
    if (newVal && newVal.length > 0) {
        getModelList()
    }
}, { deep: true })
</script>
<style scoped lang="scss">
.model-box-box {
    height: 500px;
    overflow-y: scroll;
    background: #01031B;
}

.model-box {
    // margin-left: 10px;
    // background-color: linear-gradient(90deg, #353750 0%, #323C4E 100%);
    background: linear-gradient(90deg, #353750 0%, #323C4E 100%);

    border-radius: 10px;
    padding: 10px;
    border: 1px solid transparent;

    &.active {
        border: 1px solid #7284F7;
        background: rgba(114, 132, 247, 0.1);
    }

    &.ishot {
        border: 1px solid #EE0772;
        background: rgba(244, 147, 253, 0.1) !important;

    }

    &.isCostSee {
        background: linear-gradient(90deg, #353750 0%, #323C4E 100%);
    }
}

.cost {
    background: rgba(171, 182, 255, 0.1);
}

.thinking {
    background: rgba(53, 55, 80, 1);
    border-radius: 12px;
    padding: 2px 5px;
}

.model-text {}
</style>